"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLazyLoadQuery;

var _reactRelay = require("react-relay");

// The Flow types should be almost identical except we allow skipping variables.
function useLazyLoadQuery(gqlQuery, variables, options) {
  return (0, _reactRelay.useLazyLoadQuery)(gqlQuery, variables !== null && variables !== void 0 ? variables : {}, options);
}